/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".filterdialogpickemployeeconytol .FormElement{margin-right:15px}@media (min-width:920px){.filterdialogpickemployeeconytol .u-gridHeight250 .k-grid-content{max-height:500px!important;min-height:500px}}.filter-control{display:flex}.filter-control app-multi-select{flex-basis:50%}.filter-control app-multi-select .FormElement{margin-right:0}.filter-control app-multi-select:first-child{margin-right:15px}"];
export { styles as styles };
